export default class SkippableDTO {

    public id!: number;

    public isSkipped!: boolean;

}